var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhiteGreenBgRoundedNavyBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#08AA15",
    stroke: "#333541"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9943 9.04046C21.3612 9.39988 21.4037 10.0312 21.0892 10.4505C19.2322 12.9222 17.3486 15.3939 15.2633 17.6183C14.6978 18.2214 13.9138 19.1997 13.0749 19.1997C12.4746 19.1997 11.9445 18.7603 11.5109 18.3293C10.4892 17.314 9.63247 16.0347 8.85835 14.7737C8.58122 14.3212 8.67719 13.6972 9.07309 13.3805C9.46894 13.0638 10.0145 13.1738 10.2916 13.6261L10.2927 13.6278C10.9858 14.7534 11.7456 15.9122 12.6592 16.8201C12.8119 16.9719 12.9379 17.0781 13.0346 17.1445C13.4097 16.8637 13.7427 16.5045 14.0692 16.1562C16.1074 13.9822 17.9435 11.5628 19.7603 9.14918C20.0748 8.72986 20.6274 8.68103 20.9943 9.04046Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhiteGreenBgRoundedNavyBorder);
export default __webpack_public_path__ + "static/media/checkWhiteGreenBgRoundedNavyBorder.18ea6f1ac4ec848cf68457b5b74ff27f.svg";
export { ForwardRef as ReactComponent };